//救助管理
import request from "@/utils/request.js"
import request2 from "@/utils/request2.js"
import { resolve } from "core-js/fn/promise";
//救助管理列表
export const helpManageFamilyEnvList = (params) => {
    return request({
        url: "/admin/rescueOrg/info/listRescueOrg",
        method: "POST",
        data: params
    });
}

//救助管理删除
export const helpManageFamilyEnvDelete = (params) => {
    return request({
        url: "/admin/rescueOrg/info/deleteRescueOrg",
        method: "POST",
        data: params
    });
}

//新增或者修改救助管理
export const helpManageFamilyEnvEdit = (params) => {
    return request({
        url: "/admin/rescueOrg/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//救助管理获取数据
export const helpManageFamilyEnvCheck = (params) => {
    return request({
        url: "/admin/rescueOrg/info/getRescueOrg",
        method: "POST",
        data: params
    });
}


//救助政策
//救助政策获取列表
export const helpManagePolicyList = (params) => {
    return request({
        url: "/admin/rescuePolicy/info/listRescuePolicy",
        method: "POST",
        data: params
    });
}

//救助政策删除
export const helpManagePolicyDelete = (params) => {
    return request({
        url: "/admin/rescuePolicy/info/deleteRescuePolicy",
        method: "POST",
        data: params
    });
}

//新增或者修改救助政策
export const helpManagePolicyEdit = (params) => {
    return request({
        url: "/admin/rescuePolicy/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//救助政策获取数据回写
export const helpManagePolicyCheck = (params) => {
    return request({
        url: "/admin/rescuePolicy/info/getRescuePolicy",
        method: "POST",
        data: params
    });
}

//救助政策分类
//救助政策分类获取列表
export const helpManagePolicyTypeList = (params) => {
    return request({
        url: "/admin/rescuePolicyType/info/listRescuePolicyType",
        method: "POST",
        data: params
    });
}

//救助政策分类删除
export const helpManagePolicyTypeDelete = (params) => {
    return request({
        url: "/admin/rescuePolicyType/info/deleteRescuePolicyType",
        method: "POST",
        data: params
    });
}

//新增或者修改救助政策分类
export const helpManagePolicyTypeEdit = (params) => {
    return request({
        url: "/admin/rescuePolicyType/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//救助政策分类获取数据回写
export const helpManagePolicyTypeCheck = (params) => {
    return request({
        url: "/admin/rescuePolicyType/info/getRescuePolicyType",
        method: "POST",
        data: params
    });
}


//救助类型接口
//救助类型接口列表
export const helpManageHelpTypeList = (params) => {
    return request({
        url: "/admin/rescueType/info/listRescueType",
        method: "POST",
        data: params
    });
}

//救助类型接口删除
export const helpManageHelpTypeDelete = (params) => {
    return request({
        url: "/admin/rescueType/info/deleteRescueType",
        method: "POST",
        data: params
    });
}

//新增或者修改救助类型接口
export const helpManageHelpTypeEdit = (params) => {
    return request({
        url: "/admin/rescueType/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//救助类型接口获取数据回写
export const helpManageHelpTypeCheck = (params) => {
    return request({
        url: "/admin/rescueType/info/getRescueType",
        method: "POST",
        data: params
    });
}


//救助档案
//救助档案列表
export const helpManageRecordList = (params) => {
    return request({
        url: "/admin/rescueArchives/info/listRescueArchives",
        method: "POST",
        data: params
    });
}

//救助档案删除
export const helpManageRecordDelete = (params) => {
    return request({
        url: "/admin/rescueArchives/info/deleteRescueArchives",
        method: "POST",
        data: params
    });
}

//新增或者修改救助档案
export const helpManageRecordEdit = (params) => {
    return request({
        url: "/admin/rescueArchives/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//救助档案获取数据回写
export const helpManageRecordCheck = (params) => {
    return request({
        url: "/admin/rescueArchives/info/getRescueArchives",
        method: "POST",
        data: params
    });
}

//家庭成员
//家庭成员列表
export const helpManageFamilyList = (params) => {
    return request({
        url: "/admin/rescueFamilyPerson/info/listRescueFamilyPerson",
        method: "POST",
        data: params
    });
}

//家庭成员删除
export const helpManageFamilyDelete = (params) => {
    return request({
        url: "/admin/rescueFamilyPerson/info/deleteRescueFamilyPerson",
        method: "POST",
        data: params
    });
}

//新增或者修改家庭成员
export const helpManageFamilyEdit = (params) => {
    return request({
        url: "/admin/rescueFamilyPerson/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//家庭成员获取数据回写
export const helpManageFamilyCheck = (params) => {
    return request({
        url: "/admin/rescueFamilyPerson/info/getRescueFamilyPerson",
        method: "POST",
        data: params
    });
}



//家庭成员附件
//家庭成员附件列表
export const helpManageFamilyImgList = (params) => {
    return request({
        url: "/admin/rescueEnclosure/info/listRescueEnclosure",
        method: "POST",
        data: params
    });
}

//家庭成员附件删除
export const helpManageFamilyImgDelete = (params) => {
    return request({
        url: "/admin/rescueEnclosure/info/deleteRescueEnclosure",
        method: "POST",
        data: params
    });
}

//新增或者修改家庭成员附件
export const helpManageFamilyImgEdit = (params) => {
    return request({
        url: "/admin/rescueEnclosure/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//家庭成员附件获取数据回写
export const helpManageFamilyImgCheck = (params) => {
    return request({
        url: "/admin/rescueEnclosure/info/getRescueEnclosure",
        method: "POST",
        data: params
    });
}

//家庭成员救助记录
//家庭成员救助记录列表
export const helpManageFamilyLogList = (params) => {
    return request({
        url: "/admin/rescueRecord/info/listRescueRecord",
        method: "POST",
        data: params
    });
}

//家庭成员救助记录删除
export const helpManageFamilyLogDelete = (params) => {
    return request({
        url: "/admin/rescueRecord/info/deleteRescueRecord",
        method: "POST",
        data: params
    });
}

//新增或者修改家庭成员救助记录
export const helpManageFamilyLogEdit = (params) => {
    return request({
        url: "/admin/rescueRecord/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//家庭成员救助记录获取数据回写
export const helpManageFamilyLogCheck = (params) => {
    return request({
        url: "/admin/rescueRecord/info/getRescueRecord",
        method: "POST",
        data: params
    });
}





//新增
//新增 基础库中的信息
export const helpList = (params) => {
    return request({
        url: "/admin/rescueArchives/info/listRescuePerson",
        method: "POST",
        data: params
    });
}

//新增
//POST /设为救助档案
export const helpListRescuePerson = (params) => {
    return request({
        url: "admin/rescueArchives/info/updateRescuePerson",
        method: "POST",
        data: params
    });
}

//导出
export const helpListOut = (params) => {
    return request2({
        url: "/admin/rescueRecord/info/downloadVeteransExcel",
        method: "POST",
        data: params,
        responseType: 'blob'
    });
}


//救助公示接口
//救助公示接口列表
export const helpManagePublicityList = (params) => {
    return request({
        url: "/admin/rescuePublicity/info/listRescuePublicity",
        method: "POST",
        data: params
    });
}

//救助公示接口删除
export const helpManagePublicityDelete = (params) => {
    return request({
        url: "/admin/rescuePublicity/info/deleteRescuePublicity",
        method: "POST",
        data: params
    });
}

//新增或者修改救助公示接口
export const helpManagePublicityEdit = (params) => {
    return request({
        url: "/admin/rescuePublicity/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//救助公示接口回写
export const helpManagePublicityCheck = (params) => {
    return request({
        url: "/admin/rescuePublicity/info/getRescuePublicity",
        method: "POST",
        data: params
    });
}
//拿到树
export const getTreeData = (params) => {
    return request({
        url: "/rbac/admin/org/info/OrgTreelist",
        method: "POST",
        data: params
    });
}  
//救助公示档案人员
export const getRecordData = (params) => {
    return request({
        url: "/admin/rescuePublicity/info/findRescueArchivesPublicity",
        method: "POST",
        data: params
    });
} 




//老人档案接口

//新增或者修改老人档案接口
export const oldManFileEdit = (params) => {
    return request({
        url: "/admin/OldPeople/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//回写老人档案接口
export const oldManFileCheck = (params) => {
    return request({
        url: "/admin/OldPeople/info/getOldPeople",
        method: "POST",
        data: params
    });
}
  
//列表老人档案接口
export const oldManFileList = (params) => {
    return request({
        url: "/admin/OldPeople/info/listOldPeople",
        method: "POST",
        data: params
    });
}

//删除老人档案接口
export const oldManFileDelete = (params) => {
    return request({
        url: "/admin/OldPeople/info/deleteOldPeople",
        method: "POST",
        data: params
    });
}


//老人健康接口

//新增或者修改老人健康接口
export const oldManHealthEdit = (params) => {
    return request({
        url: "/admin/Healthy/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//回写老人健康接口
export const oldManHealthCheck = (params) => {
    return request({
        url: "/admin/Healthy/info/getHealthy",
        method: "POST",
        data: params
    });
}
  
//列表老人健康接口
export const oldManHealthList = (params) => {
    return request({
        url: "/admin/Healthy/info/listHealthy",
        method: "POST",
        data: params
    });
}

//删除老人健康接口
export const oldManHealthDelete = (params) => {
    return request({
        url: "/admin/Healthy/info/deleteHealthy",
        method: "POST",
        data: params
    });
}


//老人就诊接口

//新增或者修改老人就诊接口
export const oldManSaveRecondEdit = (params) => {
    return request({
        url: "/admin/MedicalRecords/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//回写老人就诊接口
export const oldManSaveRecondCheck = (params) => {
    return request({
        url: "/admin/MedicalRecords/info/getMedicalRecords",
        method: "POST",
        data: params
    });
}
  
//列表老人就诊接口
export const oldManSaveRecondList = (params) => {
    return request({
        url: "/admin/MedicalRecords/info/listMedicalRecords",
        method: "POST",
        data: params
    });
}

//删除老人就诊接口
export const oldManSaveRecondDelete = (params) => {
    return request({
        url: "/admin/MedicalRecords/info/deleteMedicalRecords",
        method: "POST",
        data: params
    });
}


//老人体检接口

//新增或者修改老人体检接口
export const oldManPhysicalEdit = (params) => {
    return request({
        url: "/admin/PhysicalExamination/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//回写老人体检接口
export const oldManPhysicalCheck = (params) => {
    return request({
        url: "/admin/PhysicalExamination/info/getPhysicalExamination",
        method: "POST",
        data: params
    });
}
  
//列表老人体检接口
export const oldManPhysicalList = (params) => {
    return request({
        url: "/admin/PhysicalExamination/info/listPhysicalExamination",
        method: "POST",
        data: params
    });
}

//删除老人体检接口
export const oldManPhysicalDelete = (params) => {
    return request({
        url: "/admin/PhysicalExamination/info/deletePhysicalExamination",
        method: "POST",
        data: params
    });
}


//老人用药接口

//新增或者修改老人用药接口
export const oldManPharmacyEdit = (params) => {
    return request({
        url: "/admin/drug/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//回写老人用药接口
export const oldManPharmacyCheck = (params) => {
    return request({
        url: "/admin/drug/info/getDrug",
        method: "POST",
        data: params
    });
}
  
//列表老人用药接口
export const oldManPharmacyList = (params) => {
    return request({
        url: "/admin/drug/info/listDrug",
        method: "POST",
        data: params
    });
}

//删除老人用药接口
export const oldManPharmacyDelete = (params) => {
    return request({
        url: "/admin/drug/info/deleteDrug",
        method: "POST",
        data: params
    });
}


//老人帮扶记录接口

//新增或者修改老人帮扶记录接口
export const oldManHelpRecondEdit = (params) => {
    return request({
        url: "/admin/HelpRecord/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//回写老人帮扶记录接口
export const oldManHelpRecondCheck = (params) => {
    return request({
        url: "/admin/HelpRecord/info/getHelpRecord",
        method: "POST",
        data: params
    });
}
  
//列表老人帮扶记录接口
export const oldManHelpRecondList = (params) => {
    return request({
        url: "/admin/HelpRecord/info/listHelpRecord",
        method: "POST",
        data: params
    });
}

//删除老人帮扶记录接口
export const oldManHelpRecondDelete = (params) => {
    return request({
        url: "/admin/HelpRecord/info/deleteHelpRecord",
        method: "POST",
        data: params
    });
}

//咨询管理接口

//新增或者咨询管理接口
export const ConsultEdit = (params) => {
    return request({
        url: "/admin/Information/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//回写咨询管理接口
export const ConsultCheck = (params) => {
    return request({
        url: "/admin/Information/info/getInformation",
        method: "POST",
        data: params
    });
}
  
//列表咨询管理接口
export const ConsultList = (params) => {
    return request({
        url: "/admin/Information/info/listInformation",
        method: "POST",
        data: params
    });
}

//删除咨询管理接口
export const ConsultDelete = (params) => {
    return request({
        url: "/admin/Information/info/deleteInformation",
        method: "POST",
        data: params
    });
}

//咨类类型接口

//新增或者修改咨类类型接口
export const ConsultTypeEdit = (params) => {
    return request({
        url: "/admin/InformationType/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}

//回写咨类类型接口
export const ConsultTypeCheck = (params) => {
    return request({
        url: "/admin/InformationType/info/getInformationType",
        method: "POST",
        data: params
    });
}
  
//列表咨类类型接口
export const ConsultTypeList = (params) => {
    return request({
        url: "/admin/InformationType/info/listInformationType",
        method: "POST",
        data: params
    });
}

//删除咨类类型接口
export const ConsultTypeDelete = (params) => {
    return request({
        url: "/admin/InformationType/info/deleteInformationType",
        method: "POST",
        data: params
    });
}


//服务工单接口

//新增或者修改服务工单
export const oldManOrganizationWorkOrderEdit = (params) => {
    return request({
        url: "/admin/ServiceWork/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}
//回写服务工单
export const oldManOrganizationWorkOrderCheck = (params) => {
    return request({
        url: "/admin/ServiceWork/info/getServiceWork",
        method: "POST",
        data: params
    });
}
//列表服务工单
export const oldManOrganizationWorkOrderList = (params) => {
    return request({
        url: "/admin/ServiceWork/info/listServiceWork",
        method: "POST",
        data: params
    });
}
//删除服务工单
export const oldManOrganizationWorkOrderDelete = (params) => {
    return request({
        url: "/admin/ServiceWork/info/deleteServiceWork",
        method: "POST",
        data: params
    });
}


//服务公司接口
//新增或者修改服务公司
export const oldManOrganizationCompanyEdit = (params) => {
    return request({
        url: "/admin/ServiceCompany/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}
//回写服务公司
export const oldManOrganizationCompanyCheck = (params) => {
    return request({
        url: "/admin/ServiceCompany/info/getServiceCompany",
        method: "POST",
        data: params
    });
}
//列表服务公司
export const oldManOrganizationCompanyList = (params) => {
    return request({
        url: "/admin/ServiceCompany/info/listServiceCompany",
        method: "POST",
        data: params
    });
}
//删除服务公司
export const oldManOrganizationCompanyDelete = (params) => {
    return request({
        url: "/admin/ServiceCompany/info/deleteServiceCompany",
        method: "POST",
        data: params
    });
}


//服务类型接口
//新增或者修改服务类型
export const oldManOrganizationServeTypeEdit = (params) => {
    return request({
        url: "/admin/ServiceType/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}
//回写服务类型
export const oldManOrganizationServeTypeCheck = (params) => {
    return request({
        url: "/admin/ServiceType/info/getServiceType",
        method: "POST",
        data: params
    });
}
//列表服务类型
export const oldManOrganizationServeTypeList = (params) => {
    return request({
        url: "/admin/ServiceType/info/listServiceType",
        method: "POST",
        data: params
    });
}
//删除服务类型
export const oldManOrganizationServeTypeDelete = (params) => {
    return request({
        url: "/admin/ServiceType/info/deleteServiceType",
        method: "POST",
        data: params
    });
}

//服务人员接口
//新增或者修改服务人员
export const oldManOrganizationPeopleEdit = (params) => {
    return request({
        url: "/admin/ServicePerson/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}
//回写服务人员
export const oldManOrganizationPeopleCheck = (params) => {
    return request({
        url: "/admin/ServicePerson/info/getServicePerson",
        method: "POST",
        data: params
    });
}
//列表服务人员
export const oldManOrganizationPeopleList = (params) => {
    return request({
        url: "/admin/ServicePerson/info/listServicePerson",
        method: "POST",
        data: params
    });
}
//删除服务人员
export const oldManOrganizationPeopleDelete = (params) => {
    return request({
        url: "/admin/ServicePerson/info/deleteServicePerson",
        method: "POST",
        data: params
    });
}

//服务项目接口
//新增或者修改服务项目
export const oldManOrganizationserveProjectEdit = (params) => {
    return request({
        url: "/admin/ServiceProject/info/insertOrUpdate",
        method: "POST",
        data: params
    });
}
//回写服务项目
export const oldManOrganizationserveProjectCheck = (params) => {
    return request({
        url: "/admin/ServiceProject/info/getServiceProject",
        method: "POST",
        data: params
    });
}
//列表服务项目
export const oldManOrganizationserveProjectList = (params) => {
    return request({
        url: "/admin/ServiceProject/info/listServiceProject",
        method: "POST",
        data: params
    });
}
//删除服务项目
export const oldManOrganizationserveProjectDelete = (params) => {
    return request({
        url: "/admin/ServiceProject/info/deleteServiceProject",
        method: "POST",
        data: params
    });
}

//请求城市
export const getCity = (params) => {
    return request({
        url: "admin/address/info/findAddressByParentId",
        method: "POST",
        data: params
    });
}
// //党员省地址查询
// export function findAddressByParentId({
//     id
// }) {
//     let fd = new FormData()
//     fd.append("token", token)
//     fd.append("id", id)
//     return request({
//         url: "/admin/address/info/findAddressByParentId",
//         method: "POST",
//         data: fd
//     });
// }

//社区基本信息接口
//新增或者修改社区基本信息接口
export const communityInfoEdit = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismBasic/info/insertOrUpdate",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
}
//回写社区基本信息接口
export const communityInfoCheck = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismBasic/info/getMechanismBasic",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
   
}
//列表社区基本信息接口
export const communityInfoList = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismBasic/info/listMechanismBasic",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
   
}
//删除社区基本信息接口
export const communityInfoDelete = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismBasic/info/deleteMechanismBasic",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
    
}

//机构人员
//新增或者修改机构人员
export const communityPeopleEdit = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismPerson/info/insertOrUpdate",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
}
//回写机构人员
export const communityPeopleCheck = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismPerson/info/getMechanismPerson",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
   
}
//列表机构人员
export const communityPeopleList = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismPerson/info/listMechanismPerson",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
   
}
//删除机构人员
export const communityPeopleDelete = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismPerson/info/deleteMechanismPerson",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
    
}



//活动室
//新增或者修改活动室
export const communityActiveEdit = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ActivityRoom/info/insertOrUpdate",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
}
//回写活动室
export const communityActiveCheck = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ActivityRoom/info/getActivityRoom",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
   
}
//列表活动室
export const communityActiveList = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ActivityRoom/info/listActivityRoom",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
   
}
//删除活动室
export const communityActiveDelete = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ActivityRoom/info/deleteActivityRoom",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
    
}


//设备接入
//新增或者修改设备接入
export const communityEquipmentEdit = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Mequipment/info/insertOrUpdate",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
}
//回写设备接入
export const communityEquipmentCheck = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Mequipment/info/getMequipment",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//列表设备接入
export const communityEquipmentList = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Mequipment/info/listMequipment",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//删除设备接入
export const communityEquipmentDelete = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Mequipment/info/deleteMequipment",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}

//社区服务产品
//新增或者修改社区服务产品
export const communityServeProductEdit = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ServiceProducts/info/insertOrUpdate",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
}
//回写社区服务产品
export const communityServeProductCheck = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ServiceProducts/info/getServiceProducts",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//列表社区服务产品
export const communityServeProductList = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ServiceProducts/info/listServiceProducts",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//删除社区服务产品
export const communityServeProductDelete = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ServiceProducts/info/deleteServiceProducts",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}

//统计分析
export const statisticsAnalyze = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/person/info/oldPersonStatistics",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}

//机构基本信息
//新增或者修改机构基本信息
export const organizationInfoEdit = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Mechanism/info/insertOrUpdate",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
}
//回写机构基本信息
export const organizationInfoCheck = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Mechanism/info/getMechanism",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//列表机构基本信息
export const organizationInfoList = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Mechanism/info/listMechanism",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//删除机构基本信息
export const organizationInfoDelete = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Mechanism/info/deleteMechanism",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}

//工作人员
//新增或者修改工作人员
export const organizationPeopleEdit = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/WorkPerson/info/insertOrUpdate",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
}
//回写机构工作人员
export const organizationPeopleCheck = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/WorkPerson/info/getWorkPerson",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//列表工作人员
export const organizationPeopleList = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/WorkPerson/info/listWorkPerson",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//删除工作人员
export const organizationPeopleDelete = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/WorkPerson/info/deleteWorkPerson",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}


//机构养老设备接入接口
//新增或者修改机构养老设备接入接口
export const organizationEquipmentEdit = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Wequipment/info/insertOrUpdate",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
}
//回写机构养老设备接入接口
export const organizationEquipmentCheck = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Wequipment/info/getWequipment",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//列表机构养老设备接入接口
export const organizationEquipmentList = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Wequipment/info/listWequipment",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//删除机构养老设备接入接口
export const organizationEquipmentDelete = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Wequipment/info/deleteWequipment",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}

//服务产品
//新增或者修改服务产品
export const organizationServingProductEdit = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismServiceProducts/info/insertOrUpdate",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })
}
//回写服务产品
export const organizationServingProductCheck = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismServiceProducts/info/getMechanismServiceProducts",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//列表服务产品
export const organizationServingProductList = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismServiceProducts/info/listMechanismServiceProducts",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//删除服务产品
export const organizationServingProductDelete = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/MechanismServiceProducts/info/deleteMechanismServiceProducts",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}

//何康工单
export const getHeKangWorkOrder = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ServiceWork/info/hkServicePgd",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//何康对象
export const getHeKangObject = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ServiceWork/info/hkOldPerson",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}
//何康服务人员
export const getHeKangPeople = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/ServiceWork/info/hkPerson",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}

//机构统计
export const institutionStatistics = (params) => {
    return new Promise(resolve=>{
        request({
            url: "/admin/Mechanism/info/mechanismStatistics",
            method: "POST",
            data: params
        }).then(res=>{
            resolve(res)
        })
    })

}